var map = {
	"./Alcohol Swab.png": [
		5632,
		632
	],
	"./Arinac Fort Tab 100,s.png": [
		7816,
		816
	],
	"./Ascard 75mg Tab 30,s.png": [
		7296,
		296
	],
	"./Brufen 200mg Tab 100's.png": [
		944,
		944
	],
	"./Caflam 50mg Tab 20,s.png": [
		2603,
		603
	],
	"./Concor 2.5mg Tab 14,s.png": [
		1755,
		755
	],
	"./Default.png": [
		2897
	],
	"./Disprin 300mg Tab 600,s.png": [
		2236,
		236
	],
	"./Evion 400mg Cap 100,s.png": [
		6476,
		476
	],
	"./Extor 580 Tab 14,s.png": [
		1602,
		602
	],
	"./Face Mask.png": [
		3487,
		487
	],
	"./Flagyl 400mg Tab 200,s.png": [
		1148,
		148
	],
	"./Glucophage 500mg Tab 50,.png": [
		213,
		213
	],
	"./Inderal 10mg Tab 50,s.png": [
		5091,
		91
	],
	"./Inosita 100mg Tab 28s.png": [
		1062,
		62
	],
	"./Loprin 75 Mg Tab 30.png": [
		8535,
		535
	],
	"./Medicine/brufen-400-3d-pack.png": [
		8897,
		897
	],
	"./Methycobal Tab 100,s.png": [
		1357,
		357
	],
	"./Multivitamins/Vitamin C.png": [
		7038,
		38
	],
	"./Multivitamins/multivitamin ultramega.png": [
		8289,
		289
	],
	"./Nims 100mg Tab 30s.png": [
		8631,
		631
	],
	"./Norvasc 5mg 30s.png": [
		6890,
		890
	],
	"./Nuberol Forte 650mg Tab 15.s.png": [
		4104,
		104
	],
	"./Osnate D Tab 30,s.png": [
		508,
		508
	],
	"./Panadol Extra Tab (100s).png": [
		4102,
		102
	],
	"./Panadol Tab 200,s.png": [
		8385,
		385
	],
	"./Personal Care/Lavender Cream.png": [
		5148,
		617
	],
	"./Rigix Tab (30,s).png": [
		173,
		173
	],
	"./Risek 20mg Cap 21s.png": [
		6146,
		146
	],
	"./Risek 40mg Cap 21s.png": [
		1405,
		405
	],
	"./Saniplast 100,s.png": [
		5590,
		590
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4280;
module.exports = webpackAsyncContext;